import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createDiagnosis } from "../api/diagnosis.api";
import { CreateDiagnosisRow, DiagnosisRow } from "../api/diagnosis.type";
import { useToast } from "./ToastContext";
import { useUserDetails } from "./useUserDetails";

export function useCreateDiagnosis(userId?: string) {
  const queryClient = useQueryClient();
  const { showToast } = useToast();
  const { userDetails } = useUserDetails();

  const { mutate, isPending, error } = useMutation<
    DiagnosisRow,
    Error,
    CreateDiagnosisRow
  >({
    mutationFn: async (payload: CreateDiagnosisRow) => {
      return createDiagnosis(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["diagnoses", userId || userDetails?.id],
      });
      showToast("Diagnosis added", "success");
    },
    onError: (err) => {
      console.error("Error creating diagnosis:", err);
      showToast("Failed to add diagnosis", "error");
    },
  });

  return { create: mutate, isPending, error };
}

